import { useState, useEffect } from 'react';

export const TOUR_STEPS = [
  { target: '[data-tour="dashboard"]', title: 'Portfolio Dashboard', description: 'View your portfolio summary, insights, and top performers at a glance.', position: 'bottom' },
  { target: '[data-tour="investments-tab"]', title: 'Manage Investments', description: 'Add, edit, search, and filter all your investments in one place.', position: 'bottom' },
  { target: '[data-tour="continuity-tab"]', title: 'Continuity System', description: "Your private record of what you own and your trusted contacts — quietly ready for the people you nominate, if you're ever unavailable.", position: 'bottom' },
  { target: '[data-tour="export"]', title: 'Export Reports', description: 'Download your portfolio data as CSV or generate professional PDF reports.', position: 'top' },
];

export function useTourPosition(isActive, currentStep) {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!isActive) return;
    const step = TOUR_STEPS[currentStep];

    const updatePosition = () => {
      const element = document.querySelector(step.target);
      if (!element) return;
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const cardWidth = 400, cardHeight = 300, padding = 20;
      const vh = window.innerHeight;

      const left = Math.max(padding, Math.min(window.innerWidth - cardWidth - padding, rect.left + (rect.width / 2) - (cardWidth / 2)));
      let top;
      if (step.position === 'bottom') {
        top = (vh - rect.bottom >= cardHeight + 30) ? rect.bottom + scrollTop + 20 : Math.max(scrollTop + padding, rect.top + scrollTop - cardHeight - 20);
      } else {
        top = (rect.top >= cardHeight + 30) ? rect.top + scrollTop - cardHeight - 20 : rect.bottom + scrollTop + 20;
      }
      top = Math.max(scrollTop + padding, Math.min(scrollTop + vh - cardHeight - padding, top));
      setPosition({ top, left });

      const elCenter = rect.top + (rect.height / 2);
      if (elCenter < 100 || elCenter > vh - 100) {
        window.scrollTo({ top: scrollTop + elCenter - vh / 2, behavior: 'smooth' });
      }
      element.style.position = 'relative';
      element.style.zIndex = '1000';
      element.style.boxShadow = '0 0 0 4px rgba(16, 185, 129, 0.4), 0 0 20px rgba(16, 185, 129, 0.3)';
      element.style.borderRadius = '8px';
      element.style.transition = 'all 0.3s ease-in-out';
    };

    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition);
    return () => {
      const element = document.querySelector(step.target);
      if (element) { element.style.zIndex = ''; element.style.boxShadow = ''; }
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition);
    };
  }, [isActive, currentStep]);

  return position;
}
